import { defineComponent as _defineComponent } from 'vue'
import { mdiClose } from '@mdi/js'
import { computed, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BKModal',
  props: {
    isShow: { type: Boolean, default: false },
    modalWidth: { default: 630 },
    borderWidth: { default: 'medium' },
    backgroundColor: { default: '#fff' }
  },
  emits: ["update:isShow"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:isShow', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isShow: boolean, modalWidth: string | number, borderWidth: 'medium' | 'none' | 'large', backgroundColor: string };





const paddingMap = {
  medium: {
    modalWrapper: '20px 0',
    content: '0 20px',
  },
  none: {
    modalWrapper: '0',
    content: '0',
  },
  default: {
    modalWrapper: '0 20px',
    content: '20px 0',
  },
  large: {
    modalWrapper: '40px 0',
    content: '0 40px',
  },
}

const getPadding = (borderWidth: 'medium' | 'none', modalWrapper: boolean) => {
  const type = modalWrapper ? 'modalWrapper' : 'content'
  return paddingMap[borderWidth]?.[type] || paddingMap.default[type]
}

const modalWrapperCssStyles = computed(() => ({
  padding: getPadding(props.borderWidth, true),
}))

const contentCssStyles = computed(() => ({
  padding: getPadding(props.borderWidth, false),
}))

const updateScroll = (isShow: boolean) => {
  const method = isShow ? 'add' : 'remove'
  document.documentElement.classList[method]('no-scroll')
}

watch(() => props.isShow, updateScroll)

return { __sfc: true,props, emit, paddingMap, getPadding, modalWrapperCssStyles, contentCssStyles, updateScroll, mdiClose }
}

})